import React from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Image from "../../../components/AppImage";

const CarListingViewModal = ({
  isOpen,
  onClose,
  listing,
  language = "ar",
  onEdit,
  onDelete,
}) => {
  if (!isOpen || !listing) return null;

  const t = (obj) =>
    obj?.translations?.[language] || obj?.name || "-";

  const labels = {
    title: { ar: "تفاصيل السيارة", en: "Car Details" },
    price: { ar: "السعر", en: "Price" },
    year: { ar: "السنة", en: "Year" },
    distance: { ar: "المسافة", en: "Distance" },
    fuel: { ar: "الوقود", en: "Fuel" },
    gear: { ar: "القير", en: "Gear" },
    engine: { ar: "المحرك", en: "Engine" },
    import: { ar: "الاستيراد", en: "Import" },
    location: { ar: "الموقع", en: "Location" },
    contact: { ar: "التواصل", en: "Contact" },
    description: { ar: "الوصف", en: "Description" },
    features: {
  fourWheel: { ar: "دفع رباعي", en: "4WD" },
  leather: { ar: "مقاعد جلد", en: "Leather" },
  sunroof: { ar: "فتحة سقف", en: "Sunroof" },
},
  };

  const brand = t(listing?.car_brand);
  const model = listing?.car_model_details
    ? t(listing?.car_model_details)
    : listing?.car_model;

  const Feature = ({ icon, label, active }) =>
    active ? (
      <div className="flex items-center gap-1 text-xs bg-muted px-2 py-1 rounded-full">
        <Icon name={icon} size={14} />
        <span>{label}</span>
      </div>
    ) : null;

  return (
    <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center p-4">
      <div className="bg-card rounded-xl border w-full max-w-3xl max-h-[90vh] overflow-y-auto">

        {/* header */}
        <div className="sticky top-0 bg-card border-b px-6 py-4 flex justify-between">
          <h2 className="text-xl font-semibold">{labels.title[language]}</h2>
          <button onClick={onClose}>
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-6 space-y-6">

          {/* images */}
          {listing?.images?.length > 0 && (
            <div className="grid grid-cols-3 gap-3">
              {listing.images.map((img, i) => (
                <Image
                  key={i}
                  src={img.media_link}
                  className="w-full h-28 object-cover rounded-lg"
                />
              ))}
            </div>
          )}

          {/* title */}
          <div>
            <h3 className="text-lg font-bold">
              {brand} {model}
            </h3>
            <p className="text-primary font-semibold">
              {listing.price} {listing.price_in_dollars ? "USD" : "IQD"}
            </p>
          </div>

          {/* features badges */}
      <div className="flex flex-wrap gap-2">
  <Feature
    icon="Car"
    label={labels.features.fourWheel[language]}
    active={listing.four_weel}
  />

  <Feature
    icon="Armchair"
    label={labels.features.leather[language]}
    active={listing.leather_interior}
  />

  <Feature
    icon="Sun"
    label={labels.features.sunroof[language]}
    active={listing.roof_window}
  />
</div>

          {/* specs */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">

            <div>
              <p className="text-text-secondary">{labels.year[language]}</p>
              <p className="font-medium">{listing.car_year}</p>
            </div>

            <div>
              <p className="text-text-secondary">{labels.distance[language]}</p>
              <p className="font-medium">{listing.distance_driven}</p>
            </div>

            <div>
              <p className="text-text-secondary">{labels.fuel[language]}</p>
              <p className="font-medium">{t(listing.fuel_type)}</p>
            </div>

            <div>
              <p className="text-text-secondary">{labels.gear[language]}</p>
              <p className="font-medium">{t(listing.gear_type)}</p>
            </div>

            <div>
              <p className="text-text-secondary">{labels.engine[language]}</p>
              <p className="font-medium">{listing.engine_size}</p>
            </div>

            <div>
              <p className="text-text-secondary">{labels.import[language]}</p>
              <p className="font-medium">
                {t(listing.importing_country_details)}
              </p>
            </div>

          </div>

          {/* location */}
          <div>
            <p className="text-text-secondary">{labels.location[language]}</p>
            <a
              href={`https://www.google.com/maps?q=${listing.latitude},${listing.longitude}`}
              target="_blank"
              className="text-primary underline"
            >
              {t(listing.area)} - {listing.address}
            </a>
          </div>

          {/* description */}
          <div>
            <p className="text-text-secondary">{labels.description[language]}</p>
            <p>{listing.description}</p>
          </div>

          {/* contact */}
          <div>
            <p className="text-text-secondary">{labels.contact[language]}</p>
            <p>{listing.contact_information}</p>
          </div>

          {/* actions */}
          <div className="flex gap-3 pt-4">
            <Button fullWidth onClick={() => onEdit(listing)}>
              تعديل
            </Button>

            <Button variant="destructive" fullWidth onClick={() => onDelete(listing)}>
              حذف
            </Button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default CarListingViewModal;